import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DynamicViewEngineModule } from "@cotecna/dynamic-view-engine";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

//Angular material imports
import { SowFormComponent } from "./components/sow-form/sow-form.component";
import { SowSectionsComponent } from "./components/sow-sections/sow-sections.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { SowCreationComponent } from "./components/sow-creation/sow-creation.component";
import { FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";

@NgModule({
  declarations: [SowFormComponent, SowSectionsComponent, SowCreationComponent],
  imports: [
    CommonModule,
    DynamicViewEngineModule,
    //Angular Material
    MatIconModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
  exports: [SowFormComponent, SowSectionsComponent, SowCreationComponent],
})
export class ScopeOfWorkModule {}
